import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TutorialService } from '../../../../../../shared/services/tutorial.service';

@Component({
  selector: 'ngx-tutorial-overlay',
  templateUrl: './tutorial-overlay.component.html',
  styleUrls: ['./tutorial-overlay.component.scss']
})
export class TutorialOverlayComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  isVisible = false;
  dontShowAgain = false;
  animationPhase = 'start'; // start, moving, hovering, clicking, complete

  constructor(private tutorialService: TutorialService) {}

  ngOnInit(): void {
    this.tutorialService.tutorialVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe(visible => {
        this.isVisible = visible;
        if (visible) {
          this.startAnimation();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private animationTimeouts: any[] = [];

  startAnimation(): void {
    this.animationPhase = 'start';
    this.loopAnimation();
  }

  private loopAnimation(): void {
    // Clear any existing timeouts
    this.clearAnimationTimeouts();

    // Animation sequence with slower timing
    this.animationPhase = 'start';
    
    this.animationTimeouts.push(setTimeout(() => {
      if (this.isVisible) this.animationPhase = 'moving';
    }, 2000));

    this.animationTimeouts.push(setTimeout(() => {
      if (this.isVisible) this.animationPhase = 'hovering';
    }, 5000));

    this.animationTimeouts.push(setTimeout(() => {
      if (this.isVisible) this.animationPhase = 'clicking';
    }, 8000));

    this.animationTimeouts.push(setTimeout(() => {
      if (this.isVisible) this.animationPhase = 'complete';
    }, 10000));

    // Loop the animation
    this.animationTimeouts.push(setTimeout(() => {
      if (this.isVisible) {
        this.loopAnimation();
      }
    }, 12000));
  }

  private clearAnimationTimeouts(): void {
    this.animationTimeouts.forEach(timeout => clearTimeout(timeout));
    this.animationTimeouts = [];
  }

  closeTutorial(): void {
    // Clear animation timeouts when closing
    this.clearAnimationTimeouts();
    this.tutorialService.dismissTutorial(this.dontShowAgain);
  }

  onDontShowAgainChange(): void {
    // Method to handle checkbox change if needed
  }
} 